export default excludeProductId => `
  {
    filterPageItemRecommendations(excludeProductId: "${excludeProductId}") {
      id
      name
      summary
      mainVariantId
      displayedVariantId
      price
      filterValues

      variants {
        id
        colorName
        productUrl
        imageUrl
        colorCodePrimary
        colorCodeSecondary
        skus
        productData
        filterValues
      }
    }
  }
`
